import React from "react";
import { Container, Grid, Paper, Typography, Box } from "@mui/material";
import SectionHeading from "../../utils/SectionHeading";
const newsData = [
  {
    image: "/images/news1.png",
    category: "Research & Insight",
    title: "Drug Pricing and Financial Toxicity in Multiple Myeloma",
    date: "Mar 2020",
    source: "Nature — Blood Cancer Journal",
    url: "https://www.nature.com/articles/s41408-020-0338-x",
  },
  {
    image: "/images/news2.png",
    category: "Research & Insight",
    title: "Factors Associated with High U.S. Drug Prices and the Global Disparity",
    date: "Apr 2021",
    source: "PMC / NCBI",
    url: "https://pmc.ncbi.nlm.nih.gov/articles/PMC8079839/",
  },
  {
    image: "/images/news3.png",
    category: "Research & Insight",
    title: "Prescription Drug Pricing Policies Across High-Income Countries",
    date: "2024",
    source: "JAMA Health Forum",
    url: "https://jamanetwork.com/journals/jama-health-forum/fullarticle/2841230",
  },
  {
    image: "/images/news1.png",
    category: "Research & Insight",
    title: "Drug Pricing and Financial Toxicity in Multiple Myeloma",
    date: "Mar 2020",
    source: "Nature — Blood Cancer Journal",
    url: "https://www.nature.com/articles/s41408-020-0338-x",
  },
];

export default function NewsPermotion() {
  const handleCardClick = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="news_promotion_main section_space">
      <SectionHeading title={"Newsroom"} />
      <Container>
        <Grid container spacing={4} className="space-top">
          {newsData.slice(0, 3).map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <div
                onClick={() => handleCardClick(item.url)}
                style={{ textDecoration: "none", cursor: "pointer" }}
              >
                <Paper
                  elevation={3}
                  className="news_box"
                  sx={{
                    height: "100%",
                    cursor: "pointer",
                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 12px 28px rgba(0,0,0,0.14)",
                    },
                  }}
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    style={{ width: "100%", height: "180px", objectFit: "cover" }}
                  />
                  <div className="news_box_content" style={{ padding: "16px" }}>
                    <Box
                      sx={{
                        display: "inline-block",
                        backgroundColor: "#e6fffa",
                        color: "#2c7a7b",
                        fontSize: "0.68rem",
                        fontWeight: 700,
                        letterSpacing: "0.06em",
                        textTransform: "uppercase",
                        px: 1,
                        py: 0.3,
                        borderRadius: "4px",
                        mb: 1,
                      }}
                    >
                      {item.category}
                    </Box>
                    <Typography
                      variant="subtitle1"
                      className="heading_four"
                      gutterBottom
                      sx={{ fontSize: "0.92rem", fontWeight: 700, lineHeight: 1.4, color: "#1a202c" }}
                    >
                      {item.title}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "#718096", fontSize: "0.75rem" }}>
                      {item.date} · {item.source}
                    </Typography>
                  </div>
                </Paper>
              </div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}
